export const ShopBurying = {
  cid: 'c_sailor_c_b07psexz',
  cardMC: 'b_sailor_c_d9met1xe_mc',
  cardMV: 'b_sailor_c_d9met1xe_mv'
};
const shopActivity = {
  fullReduction: 2,
  deliveryActivity: 21,
  fullDiscountActivity: 3,
  promoDishes: 18,
};
// 灵犀埋点上报参数处理
export const handleLXParamShop = (data: any, shop_index: number, bizTraceId: string) => {
  // 满减活动id
  const full_reduction_activity_id = data?.shopActivityList?.find((item: any) => item.activityType === shopActivity.fullReduction)?.actId || '';
  // 配送费活动id
  const delivery_activity_id = data?.shopActivityList?.find((item: any) => item.activityType === shopActivity.deliveryActivity)?.actId || '';
  // 满折活动id
  const full_discount_activity_id = data?.shopActivityList?.find((item: any) => item.activityType === shopActivity.fullDiscountActivity)?.actId || '';
  // 折扣菜 id
  const promo_dishes = data?.shopActivityList?.find((item: any) => item.activityType === shopActivity.promoDishes)?.activityShowInfo || '';
  // 配送费原价
  const origin_delivery_price = data?.deliveryFee?.displayText || '';

  let recommended_type = '';
  if (data.recommendData != null && data.recommendData[0] != null) {
    recommended_type = data.recommendData[0]?.type ? data.recommendData[0]?.type : '';
  }
  const recommended_reason = '';
  if (data.recommendData != null && data.recommendData[0] != null) {
    recommended_type = data.recommendData[0]?.text ? data.recommendData[0]?.text : '';
  }
  const logData = data?.logData || {};
  return {
    average_price: data?.avgCostPrice?.displayText || '',
    shop_id: data?.shopId,
    shop_type: data?.shopCategoryId || '',
    shop_distance: data?.distance?.desc || '',
    delivery_time: data?.deliveryTimeDesc || '',
    delivery_price: data?.finalDeliveryFeeInfo?.price?.displayText || data?.deliveryFee?.displayText || '',
    currency_type: data?.deliveryFee?.currency || data?.avgCostPrice?.currency || '',
    picture_url: data?.shopMainPicUrl || '',
    biz_trace_id: bizTraceId,
    full_discount_activity_id,
    delivery_activity_id,
    full_reduction_activity_id,
    shop_index,
    min_price: '',
    promo_dishes,
    recommended_reason,
    recommended_type,
    shop_rating: data?.shopScoreInfo?.score || '-999',
    origin_delivery_price,
    ...logData,
  };
};

export const landingPageMcShop = (bid = '', params = {}, type: string,) => {
  const Statistics = Mach.requireModule('Statistics');
  Statistics.setTag && Statistics.setTag('sailor', {
    cid: {
      ...params,
      bid,
    },
  });
  Statistics.click(ShopBurying.cid, bid, params);
};
export const landingPageMvShop = (bid = '', params = {}, type: string,) => {
  const Statistics = Mach.requireModule('Statistics');
  Statistics.view(ShopBurying.cid, bid, params);
};
export const landingPagePvShop = (type: string) => {
  const Statistics = Mach.requireModule('Statistics');
  Statistics.pv(ShopBurying.cid, {});
};
